import { TypedUseSelectorHook, useSelector } from 'react-redux'

import type { RootState } from '../../app/store'

// * Use throughout app instead of plain `useSelector` * //
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default useAppSelector
